'use strict';

var React = require('react'),
    IconMixin = require('../../mixins/IconMixin');

var EyeIcon = React.createClass({
  mixins: [IconMixin],

  renderSVG: function (size) {
    switch (size) {
    case 'small':
      return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M9 3.5C5.58 3.5 2.6 5.72 1 9c1.6 3.29 4.58 5.5 8 5.5s6.4-2.21 8-5.5C15.4 5.72 12.42 3.5 9 3.5z"/><circle stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="9" cy="9" r="2.5"/>';
    case 'medium':
      return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M16 5.69C9.59 5.69 4 9.84 1 16c3 6.16 8.59 10.31 15 10.31S28 22.16 31 16C28 9.84 22.41 5.69 16 5.69z"/><circle stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="16" cy="16" r="4.69"/>';
    case 'large':
      return '<path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M24 8.53C14.38 8.53 6 14.76 1.5 24 6 33.24 14.38 39.47 24 39.47S42 33.24 46.5 24C42 14.76 33.62 8.53 24 8.53z"/><circle stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="24" cy="24" r="7.03"/>';
    }
  }
});

module.exports = EyeIcon;


/** WEBPACK FOOTER **
 ** ./atoms/icons/Eye.jsx
 **/